/**
 * feat-300 — every question the page renders in full, in DOCUMENT ORDER (the
 * order `ReviewBody` draws them), with the number its card shows and the keys a
 * jump needs. The counter counts only these (ADR §3.3 `needsYou` note) and
 * "jump to next" walks them in this order (NOTES §3.9).
 *
 * The numbering mirrors `DrillSection`: questions are counted in
 * `interleaveItems` order, so `Q{n}` here is the `Q{n}` on the card.
 */
import { QuizUnit } from '../../../../services/quizContentAdminService';
import { interleaveItems } from '../../QuizContentManagement';
import { GroupedCurriculum } from '../groupByTrack';
import { drillKey } from '../reviewKeys';
import type { QuestionPlacement } from './QuestionEditProvider';

export const questionItemKey = (dk: string, questionId: string): string => `${dk}-q${questionId}`;

function lessonPlacements(u: QuizUnit, out: QuestionPlacement[]): void {
  for (const d of u.drills) {
    const dk = drillKey(u.id, d.id);
    let n = 0;
    for (const item of interleaveItems(d)) {
      if (item.kind !== 'question') continue;
      n += 1;
      out.push({
        questionId: item.q.id,
        index: n,
        drillKey: dk,
        itemKey: questionItemKey(dk, item.q.id),
        lessonId: u.id,
      });
    }
  }
}

export function questionPlacements(grouped: GroupedCurriculum | null): QuestionPlacement[] {
  const out: QuestionPlacement[] = [];
  if (!grouped) return out;
  if (grouped.mode === 'flat') {
    grouped.lessons.forEach((u) => lessonPlacements(u, out));
  } else {
    for (const g of grouped.groups) {
      for (const e of g.entries) if (e.kind === 'full') lessonPlacements(e.lesson, out);
    }
  }
  return out;
}
